module.exports = __webpack_public_path__ + "img/tree-06-i-trunk.bb669da7.png";